import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import Loader from 'src/components/Loader';

import { StreamingMessageText } from '../styled';
import type { StreamProgressStep } from '../../../utils/conversationStreamEvents';

type Props = {
  steps: StreamProgressStep[];
};

/** Una riga di stato: integrata nel bubble assistente (stesso stile dello stream testuale). */
export function StreamProgressTimeline({ steps }: Props) {
  const { activeStep, doneLabels } = useMemo(() => {
    const active = [...steps].reverse().find((s) => s.status === 'active');
    const done = steps
      .filter((s) => s.status === 'done')
      .map((s) => s.label)
      .slice(-2);
    return { activeStep: active, doneLabels: done };
  }, [steps]);

  if (steps.length === 0) return null;

  return (
    <Box display="flex" flexDirection="column" gap={1} sx={{ minWidth: 0 }}>
      {doneLabels.length > 0 ? (
        <StreamingMessageText
          as="div"
          sx={{ opacity: 0.75, fontSize: '12px', lineHeight: 1.45 }}
        >
          {doneLabels.join(' · ')}
        </StreamingMessageText>
      ) : null}

      {activeStep ? (
        <Box display="flex" alignItems="center" gap={1} minWidth={0}>
          <Loader size={14} />
          <StreamingMessageText as="span" sx={{ flex: 1, minWidth: 0 }}>
            {activeStep.label}
            {activeStep.detail ? ` (${activeStep.detail})` : ''}
          </StreamingMessageText>
        </Box>
      ) : null}
    </Box>
  );
}
